import axios from 'axios';
import { auth_server,resource_server,otp_server } from "@utils/settings"


const sessionApi = axios.create({
  baseURL: resource_server,
  withCredentials: true,
  headers:{
    "Content-Type": "application/json"
  }
});

const authApi = axios.create({
  baseURL: auth_server,
  headers:{
    "Content-Type": "application/json"
  }
});
const chiusuraCassaApi = axios.create({
  baseURL: resource_server + '/chiusura_cassa',
})
const otpApi = axios.create({
    baseURL: otp_server,
    headers:{
      "Content-Type": "application/json"
    }
  });

const resourceApi = axios.create({
  baseURL: resource_server,
  withCredentials: true,
  headers:{
    "Content-Type": "application/json", 
  }
});

chiusuraCassaApi.interceptors.request.use((config)=>{
  if(import.meta.env.VITE_TOKEN) config.headers.Authorization = `Bearer ${import.meta.env.VITE_TOKEN}`
  // let url = resource_server + '/chiusura_cassa/'+moment(startDate).format('YYYYMMDD')+ '/' + moment(endDate).format('YYYYMMDD')
  //                               fetch(url).then(res=>console.log(res.json()))
  return config; 
},
(error)=> Promise.reject(error)
)

authApi.interceptors.request.use(
    (config) => {
      // const token = getCookie('token');
      if (import.meta.env.VITE_TOKEN) config.headers.Authorization = `Bearer ${import.meta.env.VITE_TOKEN}`;
      return config;
    },
    (error) => Promise.reject(error)
  );

otpApi.interceptors.request.use(
  (config) => {
          // const token = getCookie('token');
          //if (import.meta.env.VITE_TOKEN) config.headers.Authorization = `Bearer ${import.meta.env.VITE_TOKEN}`;
          return config;
  },
  (error) => Promise.reject(error)
);
sessionApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error.response.data.error_message)
); 
otpApi.interceptors.response.use(
  (response) => response.data,
  async (error) => {
    return Promise.reject(error.response.response.data.error_message);
  }
);
chiusuraCassaApi.interceptors.response.use(
  (response) => response.data,
  async (error) => {
    return Promise.reject(error.response.response.data.error_message);
  }
);
authApi.interceptors.response.use(
  (response) => response.data,
  async (error) => {
    return Promise.reject(error.response.response.data.error_message);
  }
);
resourceApi.interceptors.request.use(
    (config) => {
      // const token = getCookie('token');
      //if (import.meta.env.VITE_TOKEN) config.headers.Authorization = `Bearer ${import.meta.env.VITE_TOKEN}`;

        config.url = `/api${config.url}`;
      return config;
    },
    (error) => Promise.reject(error)
  );
  resourceApi.interceptors.response.use(
    (response) => response.data,
    async (error) => {
      return Promise.reject(error.response.data.error_message);
    }
  );
export { authApi, resourceApi,otpApi,chiusuraCassaApi,sessionApi };
